import { installIosWebkitMessageHandlerStub } from '~/utils/iosWebkitBridgeStub'

export default defineNuxtPlugin({
  name: 'ios-webkit-bridge-stub',
  enforce: 'pre',
  setup() {
    if (!import.meta.client) return
    installIosWebkitMessageHandlerStub(window)
  },
})
